export type TurnRole = "caixa" | "recepcionista";

type AppointmentStatus = {
  status: string;
};

export type TurnSignal = {
  key: "confirmations" | "payments" | "agenda" | "completed";
  count: number;
  title: string;
  description: string;
  path: string;
  tone: "amber" | "emerald" | "blue" | "violet";
};

export function buildRoleTurnSignals(
  role: TurnRole,
  appointments: AppointmentStatus[] = [],
  unpaidCount = 0,
): { priority: TurnSignal; signals: TurnSignal[]; summary: string } {
  const pendingConfirmations = appointments.filter((appointment) => appointment.status === "pending").length;
  const confirmedAppointments = appointments.filter((appointment) => appointment.status === "confirmed").length;
  const completedAppointments = appointments.filter((appointment) => appointment.status === "completed").length;

  const confirmations: TurnSignal = {
    key: "confirmations",
    count: pendingConfirmations,
    title: pendingConfirmations > 0
      ? `${pendingConfirmations} confirmação${pendingConfirmations > 1 ? "ões" : ""} pendente${pendingConfirmations > 1 ? "s" : ""}`
      : "Agenda confirmada",
    description: pendingConfirmations > 0
      ? "Revise os próximos horários antes do atendimento."
      : "Não há horários aguardando confirmação hoje.",
    path: "/appointments",
    tone: "amber",
  };
  const payments: TurnSignal = {
    key: "payments",
    count: unpaidCount,
    title: unpaidCount > 0
      ? `${unpaidCount} pagamento${unpaidCount > 1 ? "s" : ""} aguardando`
      : "Caixa em dia",
    description: unpaidCount > 0
      ? "Receba os atendimentos concluídos que ainda estão pendentes."
      : "Não há atendimentos concluídos aguardando recebimento.",
    path: "/checkout",
    tone: "emerald",
  };
  const agenda: TurnSignal = {
    key: "agenda",
    count: confirmedAppointments,
    title: `${confirmedAppointments} atendimento${confirmedAppointments === 1 ? " confirmado" : "s confirmados"}`,
    description: "Acompanhe os próximos horários e prepare a recepção.",
    path: "/appointments",
    tone: "blue",
  };
  const completed: TurnSignal = {
    key: "completed",
    count: completedAppointments,
    title: `${completedAppointments} atendimento${completedAppointments === 1 ? " concluído" : "s concluídos"}`,
    description: "Confira os atendimentos finalizados durante o turno.",
    path: "/checkout",
    tone: "violet",
  };

  const priority = role === "caixa"
    ? (payments.count > 0 ? payments : confirmations.count > 0 ? confirmations : agenda)
    : (confirmations.count > 0 ? confirmations : payments.count > 0 ? payments : agenda);

  const signals = role === "caixa"
    ? [payments, completed, confirmations, agenda]
    : [confirmations, agenda, payments, completed];

  return {
    priority,
    signals,
    summary: `${pendingConfirmations} a confirmar · ${confirmedAppointments} confirmados · ${completedAppointments} concluídos · ${unpaidCount} pagamento${unpaidCount === 1 ? "" : "s"} pendente${unpaidCount === 1 ? "" : "s"}`,
  };
}
